<div class="input-group">
  <input (blur)="touched()" (input)="changed($event)" [disabled]="disabled"
         [type]="this.hide() ? 'password' : 'text'"
         [value]="value"
         autocomplete="off"
         class="form-control"
  >
  <button (click)="toggleHide()" class="btn btn-secondary" type="button">
    <i [ngClass]="{'fa-eye': !this.hide(), 'fa-eye-slash': this.hide()}" class="fa-solid"></i>
  </button>
</div>
